import { inject, Injectable } from '@angular/core';
import { ScormService } from '../../services';
import { ENV, Environment } from '../../types';

@Injectable({
  providedIn: 'root',
})
export class DownloadService {
  private _scormService = inject(ScormService);
  private _env = inject<Environment>(ENV);

  download(downloadFile: { name: string; source: string }): void {
    const url = this._getDocumentUrl(downloadFile.source);
    // https://medium.com/charisol-community/downloading-resources-in-html5-a-download-may-not-work-as-expected-bf63546e2baa
    // Workaround : impossible to identify from where came from the following bug, so we change the method to download using a blob
    // Bug : From the clients LMS and Storiz (weird different behavior between Storiz preprod / prod), problem when clicking a button to download a pdf file
    fetch(url)
      .then((res: Response) => res.blob())
      .then((res: Blob) => {
        const a = document.createElement('a');
        a.href = URL.createObjectURL(res);
        a.download = downloadFile.name;
        document.body.appendChild(a);
        a.click();
        setTimeout(() => {
          window.URL.revokeObjectURL(url);
          window.document.body.removeChild(a);
        }, 0);
      });
  }

  private _getDocumentUrl(source: string): string {
    if (this._scormService.isScormActive) {
      // scorm document have relative URL ('./myResource') those URL are not parsable by native `new URL()`
      return source;
    }
    const parsedSource = new URL(source);
    parsedSource.searchParams.set('download', 'true'); // get original media
    const isStorizDomain = this._env.domainList
      .map(strDomain => strDomain.replace('.', '\\.') + '$') // turn string to regexp ('.' are escaped and the domain should end with the tested value (not just containing it))
      .some(strRegExpDomain => new RegExp(strRegExpDomain).test(parsedSource.hostname));

    const urlWithoutDomain = parsedSource.pathname + parsedSource.search; // when in storiz environment the domain is dropped to avoid CORS while downloading files
    return isStorizDomain ? urlWithoutDomain : parsedSource.toString();
  }
}
